
<template>
  <v-container fluid>
    <v-layout row wrap justify-end>
      <v-btn
        color="primary"
        @click="$router.push({path: '/Application'})"
      >New Application</v-btn>
    </v-layout>
    <v-layout>
      <v-flex xs12 md3 pr-4>
        <v-text-field label="Application ID" v-model="search.Id"></v-text-field>
      </v-flex>
      <v-flex xs12 md3 pr-4>
        <v-status label="Status" v-model="search.Status"></v-status>
      </v-flex>
      <v-flex xs12 md6 pr-4>
        <sites label="Practice Site" v-model="search.Site"></sites>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-btn color="secondary" @click="search = {}">Clear</v-btn>
      <v-btn color="primary" @click="searchApps">Search</v-btn>
    </v-card-actions>
    <v-card class="mt-4" elevation="1">
      <v-card-title>Applications</v-card-title>
      <v-data-table :items="filtered" :headers="headers">
        <template slot="items" slot-scope="props">
          <tr style="text-align:left;">
            <td>
              <v-btn icon color="primary" @click="open(props.item.Id)"><v-icon>open_in_new</v-icon></v-btn>
              {{props.item.Id}}              
            </td>
             <td>            
              {{props.item.User.FirstName}} {{props.item.User.LastName}}
            </td>
            <td>{{primarySiteName(props.item.PracticeSiteInformation)}}</td>
            <td>{{props.item.CreatedOn | formattedDate}}</td>
            <td>{{currentStatus(props.item.CurrentStatus)}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
import moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import LuStatusVue from '../LuStatus.vue'
import SiteAddressVue from '../SiteAddress.vue'
const moduleNameSpace = 'applications'
export default {
  name: 'UserInbox',
  data() {
    return {
      search: {
        Id: '',
      },
      headers: [
        { text: 'ApplicationID', value: 'Application.ID' },
        { text: 'Healthcare Provider', value: 'User.FirstName' },
        { text: 'Practice Site', value: 'SiteInsitutionName' },
        { text: 'Application Created', value: 'CreatedOn' },
        { text: 'Status', value: 'Description' },
      ],
      filtered: []
    }
  },
  created(){
    this.getApplications()
  },
  methods: {
    ...mapActions(moduleNameSpace, ['getApplications']),
    primarySiteName(sites) {
      let name = ''
      sites.forEach((i) => {
        if (i.IsPrimarySite) {
          name = i.SiteAddress.SiteInsitutionName
        }
      })
      return name
    },
    open(id){
      this.$router.push({path: `Application/${id}`})
    },
    currentStatus(status){
      if(status.Status){
        return status.Status.Description
      }
      return ''
    },
    searchApps(){
      this.filtered = JSON.parse(JSON.stringify(this.applications))
      if(this.search.Id){
        this.filtered = this.filtered.filter(i => {
          return i.Id == this.search.Id
        })
      }
      if(this.search.Status){
        this.filtered = this.filtered.filter(i => {
          return i.CurrentStatus.StatusID == this.search.Status
        })
      }
      if(this.search.Site){
        this.filtered = this.filtered.filter(i => {
          let primary = {} 
          i.PracticeSiteInformation.forEach(p => {
            if(p.IsPrimarySite){
              primary = p
            }
          })
          return primary.SiteAddressID == this.search.Site
        })
      }
    }
  },
  computed: {
    ...mapGetters(moduleNameSpace, ['applications'])
  },
  watch: {
    applications: {
      handler(val){
        if(val && val.length > 0){
          this.filtered = JSON.parse(JSON.stringify(val))
        }
      }, 
      deep: true
    }
  },
  components: {
    'v-status': LuStatusVue,
    'sites' : SiteAddressVue
  },
}
</script>

